const IS_CLIENT_RENDERED = typeof window !== "undefined";

export default IS_CLIENT_RENDERED;



// WEBPACK FOOTER //
// ./src/util/isClientRendered.js